var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.alert.type,{tag:"component",nativeOn:{"click":function($event){return _vm.removeAlert.apply(null, arguments)}}},[_c('p',{attrs:{"slot":"text"},slot:"text"},[_vm._v(_vm._s(_vm.alert.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }